import styled from 'styled-components';

export const LfcWrapper = styled.section`
  display: flex;
  flex-direction: column;

  @media (min-width: 768px) {
    flex-direction: row;
  }

  .title-long-and-ratings {
    margin-bottom: 10px;
  }
`;

export const ProductInfoWrapper = styled.section`
  display: flex;
  flex: 1 1 100%;
  flex-direction: column;
  min-width: auto;

  @media (min-width: 768px) {
    flex: 1 1 50%;
  }
`;
